import React from "react";
import {
  Box,
  Image,
  Text,
  Heading,
  Badge,
  IconButton,
  HStack,
  Button,
} from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import Translate from "../../LanguageTranslation/Translate";
import { FaHeart, FaPen } from "react-icons/fa";
import { useCurrency } from "../../CurrencyExchange/CurrencyContext";
import ExternalLinkButton from "../../ExternalLinkButton";
import DefaultImage from "../../../assets/images/bucketlist_icons/Accommodations.png";

const AccommodationCard = ({ hotel, manual, handleDelete, handleEdit }) => {
  const { convertCurrency, currency } = useCurrency();
  // console.log("HotelCard", hotel);

  const convertedPrice = convertCurrency(
    hotel?.price?.perNight,
    hotel?.price?.currency
  );

  // Function to handle box click and open link
  const handleBoxClick = () => {
    window.open(hotel.link, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer"
      onClick={handleBoxClick}
    >
      <Box position="relative">
        <Image
          src={
            hotel.images && hotel.images[0]?.large
              ? `https:${hotel.images[0].large}`
              : DefaultImage
          }
          fallbackSrc={DefaultImage}
          alt={hotel.title || "Hotel Image"}
          width="100%"
          height="30vh"
          objectFit="cover"
        />

        <IconButton
          aria-label="Add to favorites"
          icon={<FaHeart />}
          size="md"
          bg="none"
          _hover={{ bg: "none" }}
          position="absolute"
          top="3px"
          right="3px"
          borderRadius="full"
          color="red.500"
          onClick={handleDelete}
        />
      </Box>
      <Box p="6">
        <HStack mb={3}>
          <Heading display="flex" size="sm" mb="0" noOfLines={1}>
            <Translate text={hotel.title || "Hotel Title"} />
          </Heading>
          {manual === "manual" && (
            <IconButton
              aria-label="Edit accommodation"
              icon={<FaPen />}
              size="sm"
              bg="none"
              _hover={{ bg: "gray.100" }}
              ml={2}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(hotel);
              }}
            />
          )}
        </HStack>
        <HStack mb="2">
          {
            hotel.rating?.value && (
              <Box display="flex" alignItems="center">
                <HStack spacing={1}>
                  <StarIcon boxSize={3} color="#3A4135" mb={0} />
                  <Text color="#1A202C" fontWeight="bold" fontSize="sm" mb={0}>
                    {(hotel.rating.value / 10).toFixed(1)}
                  </Text>
                  <Text fontSize="xs" color="gray.500" mb={0}>
                    ({hotel.rating.value} reviews)
                  </Text>
                  <Text mb={0}>,</Text>
                </HStack>
              </Box>
            )
            // <Text color="gray.500" fontSize="sm" mb={0}>
            //   <Translate text="No reviews available" />
            // </Text>
          }
          <HStack spacing={1} ml={0} alignItems="flex-start">
            <Text fontWeight="bold" fontSize="sm" color="gray.800" mb={0}>
              {currency} {convertedPrice.toLocaleString()}{" "}
            </Text>
            <Text fontSize="sm" color="gray.800" mb={0}>
              <Translate text="night" />
            </Text>
          </HStack>
        </HStack>
        {/* Book Button */}
        <ExternalLinkButton
          as="a"
          href={hotel.link}
          rel="noopener noreferrer"
          mt={2}
          size="sm"
          bg="#286328"
          _hover="none"
          _active="none"
          textColor="white"
          width="full"
        >
          <Translate text="Book" />
        </ExternalLinkButton>
      </Box>
    </Box>
  );
};

export default AccommodationCard;
